import { render } from "./prjCard.vue?vue&type=template&id=f22e2810&scoped=true"
import script from "./prjCard.vue?vue&type=script&lang=js"
export * from "./prjCard.vue?vue&type=script&lang=js"

import "./prjCard.vue?vue&type=style&index=0&id=f22e2810&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22e2810"],['__file',"src/components/prjCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f22e2810"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f22e2810', __exports__)) {
    api.reload('f22e2810', __exports__)
  }
  
  module.hot.accept("./prjCard.vue?vue&type=template&id=f22e2810&scoped=true", () => {
    api.rerender('f22e2810', render)
  })

}


export default __exports__